import { MantineThemeOverride } from '@mantine/core'
import { doclenzBlue, doclenzTeal, doclenzGray, DoclenzTokens } from './palette'

const T = DoclenzTokens.dark

/**
 * Tema escuro do Doclenz Admin.
 *
 * Mesma paleta azul do tema claro; o que muda são as superfícies — fundo quase preto azulado,
 * cartões em azul-marinho profundo. Os halos do fundo ficam mais discretos, porque sobre escuro
 * o mesmo alfa se destaca mais.
 */
export const AppThemeDark: MantineThemeOverride = {
  primaryColor: 'appPrimary',
  primaryShade: 6,
  colors: {
    appPrimary: doclenzBlue,
    appAccent: doclenzTeal,
    appGray: doclenzGray,
    doclenzBlue,
    doclenzTeal,
  },
  defaultRadius: 'lg',
  radius: {
    xs: '6px',
    sm: '9px',
    md: '11px',
    lg: '16px',
    xl: '22px',
  },
  fontFamily: 'Inter, system-ui, sans-serif',
  headings: {
    fontFamily: 'Inter, system-ui, sans-serif',
    fontWeight: '700',
  },
  shadows: {
    xs: '0 4px 14px rgba(0,0,0,.14)',
    sm: '0 6px 20px rgba(0,0,0,.20)',
    md: T.shadow,
    lg: '0 16px 44px rgba(0,0,0,.34)',
    xl: '0 22px 60px rgba(0,0,0,.40)',
  },
  components: {
    AppShell: {
      styles: {
        navbar: {
          border: 'none',
          backgroundImage: DoclenzTokens.sidebarGradient,
          backgroundColor: DoclenzTokens.navy950,
        },
        header: {
          borderBottom: `1px solid ${T.border}`,
          backgroundColor: T.surface,
        },
        main: {
          backgroundColor: T.bg,
          backgroundImage:
            'radial-gradient(circle at 85% 8%, rgba(30,196,212,.08), transparent 26%),' +
            'radial-gradient(circle at 15% 88%, rgba(42,99,196,.06), transparent 28%)',
          backgroundAttachment: 'fixed',
        },
      },
    },
    Card: {
      defaultProps: {
        shadow: 'md',
        radius: 'lg',
        withBorder: true,
      },
      styles: {
        root: {
          backgroundColor: T.surface,
          borderColor: T.border,
          color: T.text,
        },
      },
    },
    Paper: {
      styles: {
        root: {
          backgroundColor: T.surface,
          borderColor: T.border,
          color: T.text,
        },
      },
    },
    Button: {
      defaultProps: {
        radius: 'sm',
      },
    },
    Badge: {
      styles: {
        root: {
          textTransform: 'none',
        },
      },
    },
    Table: {
      styles: {
        th: {
          color: T.muted,
          fontWeight: 700,
          backgroundColor: T.surface2,
        },
      },
    },
    Code: {
      styles: {
        root: {
          backgroundColor: T.surface3,
          color: T.text,
        },
      },
    },
    Tooltip: {
      styles: {
        tooltip: {
          fontWeight: '500',
        },
      },
    },
  },
}
